import { forceCollapseMenu, setHeaderNavLocation, setHeaderStyle, setMenuState, setSlugState, setRouterState, collapseMenu } from './header_nav_location';
import homeIncrementTrigger from './home_counter';
import staticContentFetchData from './static_content';
import { setScrollState, setResizeState, setDirectionDown, scrollDirection, scrollData, setScrollDirection } from './a_window_data';
import { setCatNav, setCatPage, categorySelectedTrigger } from './a_category_nav';
import { setVideoPlaying  } from './a_media_controls';

export {
  setHeaderNavLocation,
  setHeaderStyle,
  homeIncrementTrigger,
  staticContentFetchData,
  categorySelectedTrigger,
  setScrollState,
  setResizeState,
  setMenuState,
  setSlugState,
  setCatNav,
  setCatPage,
  setDirectionDown,
  scrollDirection,
  setScrollDirection,
  scrollData,
  setVideoPlaying,
  setRouterState,
  collapseMenu,
  forceCollapseMenu
};



// WEBPACK FOOTER //
// ./src/redux/actions/index.js